import React, { useEffect, useState } from "react";
import { Collapse, Divider, Row } from "antd";
import { fetchServiceRateVersions, offeringActions } from "../../../store/slices/offering/offering";
import { toHttpFormatStartOfDay } from "../../../lib/utils";
import { useAppDispatch, useAppSelector } from "../../..";
import { hasAccess } from "../../RolesModule/hasAccess";
import { MENU_ADMIN_OFFERING_WRITE } from "../../../lib/const/permissions";
import HistoryAndPropertyModal from "../../HistoryAndPropertyModal/HistoryAndPropertyModal";
import { useAccountProductsContainerContext } from "../../../containers/AccountProductsContainer/context/AccountProductsContainerContext";
import { fetchTax } from "../../../store/slices/taxTs";
import { ServiceRateView } from "../../common/ServiceRate/ServiceRateView/ServiceRateView";

export const ProductsTarificationParams = () => {
  const { activeOfferVersion } = useAccountProductsContainerContext();
  const dispatch = useAppDispatch();

  const { serviceRates } = useAppSelector((state) => state.offering);

  const { aggregationRules } = useAppSelector((state) => state.aggregationRules);

  // Исходная загрузка ставки налога для отображения в таблице цен
  useEffect(() => {
    if (activeOfferVersion?.serviceTypeId) {
      dispatch(
        fetchTax({
          serviceTypeId: activeOfferVersion.serviceTypeId,
          amount: 1, // Нужна только ставка налога, поэтому передается 1
          amountType: "NET",
          onDate: toHttpFormatStartOfDay(activeOfferVersion?.fromDate),
        })
      );
    }
  }, [activeOfferVersion?.fromDate]);

  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [objectId, setObjectId] = useState<number | null>(null);

  const showHistoryModal = (rateId: number) => {
    setHistoryModalVisible(true);
    setObjectId(rateId || null);
  };

  const [isVersionsOpen, setIsVersionsOpen] = useState<boolean>(false);
  const [isCollapseOpen, setIsCollapseOpen] = useState<boolean>(true);

  const toggleCollapse = () => {
    setIsCollapseOpen((prev) => !prev);
  };

  const onClickVersionIcon = (rateId: number, isVersionsOpen: boolean) => {
    if (isVersionsOpen) {
      dispatch(offeringActions.cleanServiceRateVersions());
      setIsVersionsOpen(false);
    } else {
      dispatch(fetchServiceRateVersions(rateId));
      setIsVersionsOpen(true);
    }
  };

  return (
    <div className="tariffication-params-container">
      <Divider className="tariffication-params-container__upperDivider" />
      <Collapse activeKey={isCollapseOpen ? ["1"] : []} bordered={false} onChange={toggleCollapse}>
        <Collapse.Panel
          key="1"
          header={
            <Row justify="space-between" className="tariffication-params-container__pageTitle">
              <h3>Параметры тарификации</h3>
            </Row>
          }
        >
          <Divider style={{ margin: 0 }} />
          {activeOfferVersion?.serviceRates && serviceRates && (
            <ServiceRateView
              serviceRates={serviceRates}
              showHistoryModal={showHistoryModal}
              onClickVersionIcon={onClickVersionIcon}
              isProductDetails
              aggregationRules={aggregationRules}
            />
          )}
        </Collapse.Panel>
      </Collapse>
      <HistoryAndPropertyModal
        objectTypeSysname="service_rate"
        objectId={objectId}
        handleHideModal={() => setHistoryModalVisible(false)}
        visibleModal={historyModalVisible}
        hasAccessToEdit={hasAccess(MENU_ADMIN_OFFERING_WRITE)}
      />
    </div>
  );
};
